module.exports = __webpack_public_path__ + "static/img/RAPD-1U460-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPD-1U460-G_1.png
// module id = GxWJ
// module chunks = 0